angular.module('qkr').controller('TransactionOutletController', ($scope, $uibModalInstance, $timeout,
                                                                 savedReport, reportService, APP_CONSTANT, appConfig,
                                                                 reportsErrorService, utils, merchantService,
                                                                 gettextCatalog, reportInfo, departments,
                                                                 isMerchantReport, outlets, outletService, _) => {

    const vm = $scope;
    const now = new Date() * 1;
    vm.isMerchantLocationReport = isMerchantReport;
    const defaultScheduleInterval = 'daily';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 30;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;
    const defaultDaysOfBankCutOff = '5d';
    vm.outlets = outlets;

    const isUpdating = Boolean(savedReport);

    vm.daysOfMonth = reportService.getDaysOfMonth();
    vm.daysOfWeek = utils.getDaysOfWeek(); // Drop down menu to choose which day to generate weekly report
    vm.days = utils.getDaysOfWeekWithSelected(); // Used to select which days a daily report should be generated on
    vm.scheduleIntervals = [];
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();
    vm.display = {allSelected: ' Deselect All'};

    vm.templateReport = [];
    vm.templateReportTemplate = [];
    vm.isAustralianSchool = false;

    vm.isSupplier = (appConfig.businessCategory === 'Supplier');

    vm.sendProtocolOptions = [
        {description: gettextCatalog.getString('Email'), type: 'EMAIL'},
        {description: gettextCatalog.getString('SFTP'), type: 'SFTP'},
        {description: gettextCatalog.getString('Amazon S3'), type: 'S3'}
    ];

    vm.form = {};

    vm.transactionReportSettings = {
        reportWaiting: false,
        reportUrl: '',
        showGenerateButton: !(isUpdating || merchantService.behaviour(merchantService.merchantInfo,
            'reportPage.collapseHeaders')),
        showSaveButton: isUpdating
    };

    vm.transactionReport = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: null,
        endTime: null,
        reportSpec: {
            reportSubType: APP_CONSTANT.REPORT_TRANSACTION_DETAILS,
            departments: [],
            reportFileType: 'xls'
        }
    };

    vm.transactionReportTemplate = {
        reportSpec: {
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: [],
            scheduleMinute: defaultScheduleMinute,
            reportSubType: APP_CONSTANT.REPORT_TRANSACTION_DETAILS,
            departments: [],
            daysOfBankCutOff: defaultDaysOfBankCutOff,
            reportFileType: 'xls',
            sendProtocol: 'EMAIL'
        }
    };

    vm.departments = departments;

    function poll(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report
            reportService.pollReport(id)
                .then((promise) => {
                        // Check if error on the report
                        if (promise.error) {
                            handleGenerateReportError(promise.error);
                        } else if (promise.reportType === 'no-data') {
                            vm.form.transactionReportForm.errors = {
                                generate: gettextCatalog.getString('No data for these criteria')
                            };
                            vm.transactionReportSettings.reportWaiting = false;
                        }
                        // Check if complete, otherwise poll again
                        else if (promise.percentComplete === 100) {
                            vm.form.transactionReportForm.errors = {};
                            vm.transactionReportSettings.reportWaiting = false;
                            vm.transactionReportSettings.reportUrl = appConfig.apiUrl +
                                'reportControl/' + promise.id + '/' + format;
                            window.location = vm.transactionReportSettings.reportUrl;
                        } else {
                            poll(id, format, reportType);
                        }
                    },
                    (error) => {
                        handleGenerateReportError(error);
                    });
        }, 2500);

        // When the DOM element is removed from the page, AngularJS will trigger
        // The $destroy event on
        // The scope. This gives us a chance to cancel any pending timer that we
        // May have.
        vm.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
        );
    }

    function handleGenerateReportError (error) {
        let errors = {};

        if (vm.form.transactionReportForm.errors) {
            errors = vm.form.transactionReportForm.errors;
        }
        if (angular.isString(error)) {
            errors.generate = error;
        }
        else {
            errors.generate = gettextCatalog.getString('Error generating report');
        }
        vm.form.transactionReportForm.errors = errors;
        vm.transactionReportSettings.reportWaiting = false;
    }

    vm.showDepartments = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'transReportPage.showDepartments');
    };

    vm.showHeaderDisplayFields = function() {
        return merchantService.behaviour(merchantService.merchantInfo, 'transReportPage.showHeaderDisplayFields');
    };

    /**
     * Update departments list shown on form from list of departments and set
     * the ones that should be selected
     */
    function updateDepartmentsList(reportSpec, departments) {
        reportSpec.departments = [];
        let selectedCount = 0;
        for (var i = 0; i < departments.length; ++i) {
            let selected = false;

            if (!(typeof reportSpec.merchantLocs === 'undefined')) {
                for (let j = 0; j < reportSpec.merchantLocs.length; j++) {
                    if (reportSpec.merchantLocs[j].id == departments[i].id) {
                        selected = true;
                        selectedCount++;
                    }
                }
            }
            reportSpec.departments.push({id: departments[i].id, name: departments[i].name, selected});
        }

        // If no departments are selected then select all of them (none selected
        // Means report will contain
        // All departments, so may as well show them all ticked as it is the
        // Same thing). Also when a
        // New report is being created they will all be selected so they just
        // Need to unselect ones they
        // Don't want (typically Canteen).
        if (selectedCount === 0) {
            for (var i = 0; i < departments.length; ++i) {
                reportSpec.departments[i].selected = true;
            }
        }
    }

    vm.generateTransactionReport = function() {
        vm.transactionReportSettings.reportWaiting = true;
        const request = angular.copy(vm.transactionReport);
        request.reportSpec.scheduleInterval = 'once';
        request.startTime = utils.dateTimeToServerDateTimeString(vm.transactionReport.date.startDate,
            vm.transactionReport.date.startTime); // Start of day
        request.endTime = utils.dateTimeToServerDateTimeString(vm.transactionReport.date.endDate,
            vm.transactionReport.date.endTime); // End of day
        setMerchantLocIds(request.reportSpec, vm.transactionReport.reportSpec);

        if (request.reportSpec.reportFileType === 'csv') {
            request.reportSpec.reportSubType = request.reportSpec.reportSubType + request.reportSpec.reportFileType;
        }
        delete (request.date);
        delete (request.reportSpec.reportFileType);

        // Add selected headers to reportSped custom fields
        request.reportSpec.customFields = [];

        if (merchantService.merchantInfo.contactDetails.country.isoCode === 'AU' && reportInfo.reportType) {
            request.reportSpec.customFields.push('Family number');
        }
        for (const i in vm.templateReport.headers) {
            if (vm.templateReport.headers[i].selected) {
                request.reportSpec.customFields.push(vm.templateReport.headers[i].name);
            }
        }

        reportService.generateTransactionReport(request).then(
            (promise) => {
                poll(promise.id, 'excel', 'transaction');
            },
            (error) => {
                handleGenerateReportError(error);
            }
        );
    };

    /**
     * Set the merchantLocs that are selected in the report spec (that will be
     * sent to server)
     */
    function setMerchantLocIds(requestReportSpec, reportSpec) {
        requestReportSpec.merchantLocs = [];
        if (typeof reportSpec.departments === 'undefined') {
            reportSpec.departments = [];
        }
        for (let i = 0; i < reportSpec.departments.length; ++i) {
            if (reportSpec.departments[i].selected) {
                requestReportSpec.merchantLocs.push({id: reportSpec.departments[i].id});
            }
        }
        delete requestReportSpec.departments; // Don't send departments to
        // Server
    }

    // Transform in a json object
    function transformHeader(groupByList) {
        const tmp = [];
        // Transform groupByList, Add selected key to all so we can use this as
        // Model for toggle on/off
        for (let i = 0; i < groupByList.length; i++) {
            const selected = true;

            tmp.push({name: groupByList[i], selected});
        }

        return tmp;
    }

    vm.selectAll = function() {
        angular.forEach(vm.transactionReport.reportSpec.departments, setDepartment);
        angular.forEach(vm.transactionReportTemplate.reportSpec.departments, setDepartment);
    };

    function setDepartment(department) {
        department.selected = vm.display.allSelected === ' Deselect All';
    }

    vm.isAllSelected = function() {
        return vm.departments.every(department => department.selected);
    };

    vm.saveTransactionReport = function() {
        if (!validateReport()) {
            return;
        }

        vm.saving = true;

        const request = angular.copy(vm.transactionReportTemplate.reportSpec);
        setMerchantLocIds(request, vm.transactionReportTemplate.reportSpec);

        if (request.scheduleInterval === 'daily') {
            request.scheduleDay = utils.getSelectedDaysList(vm.days);
        }

        // Are we updating or creating, if savedReport object passed to modal we
        // Are updating, otherwise we are creating
        if (!isUpdating) {
            request.id = null;
        }

        if (request.reportSubType === APP_CONSTANT.REPORT_TRANSACTION_DETAILS && request.reportFileType === 'csv') {
            request.reportSubType = request.reportSubType + '_' + request.reportFileType;
            delete (request.reportFileType);
        }

        if (request.sendProtocol === 'SFTP') {
            request.sendProtocolParamsStr = angular.toJson(request.sendProtocolParams, false);
        }

        // Add selected headers to reportSped custom fields
        request.customFields = [];
        if (reportInfo.reportType) {
            request.customFields.push('Family number');
        }
        for (const i in vm.templateReportTemplate.headers) {
            if (vm.templateReportTemplate.headers[i].selected) {
                request.customFields.push(vm.templateReportTemplate.headers[i].name);
            }
        }

        reportService.saveTransactionReport(request, isUpdating)
            .then(() => {
                $uibModalInstance.close(true);
            })
            .catch(rs => {
                vm.form.transactionReportForm.errors = reportsErrorService
                    .handleServerError(rs.data.errors);
            })
            .finally(() => {
                vm.saving = false;
            });
    };

    function validateReport() {
        // Empty the errors list
        vm.errors = null;
        let valid = true;
        const errors = {};

        // Check name is set
        if (vm.form.transactionReportForm.name.$invalid) {
            errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        // Check at least 1 email is added
        if (vm.transactionReportTemplate.reportSpec.sendProtocol === 'EMAIL' &&
            vm.transactionReportTemplate.reportSpec.emailList.length <= 0) {
            errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }
        
        const sendProtParams = vm.transactionReportTemplate.reportSpec.sendProtocolParams;
        const isSFTP = vm.transactionReportTemplate.reportSpec.sendProtocol === 'SFTP';

        if (isSFTP && sendProtParams && (sendProtParams.password == null || sendProtParams.password === '')) {
            errors.password = gettextCatalog.getString('Please enter SFTP password');
            valid = false;
        }
        
        vm.form.transactionReportForm.errors = errors;

        return valid;
    }

    vm.addTransactionReportEmail = function() {
        // Gets ride of validation warning
        if (vm.form.transactionReportForm.errors && vm.form.transactionReportForm.errors.email) {
            vm.form.transactionReportForm.errors.email = '';
        }
        vm.transactionReportTemplate.reportSpec.emailList.push(vm.transactionReportSettings.email);
        vm.transactionReportSettings.email = '';
    };

    vm.removeTransactionReportEmail = function(index) {
        vm.transactionReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    /* Init */
    vm.init = function() {
        if(isUpdating) {
            loadSavedReport(savedReport);
            if(!savedReport.departments) {
                savedReport.departments = [];
            }
            angular.forEach(outlets, (outlet) => {
                angular.forEach(savedReport.merchantLocs, (savedOutlet) => {
                    if(savedOutlet.bean === 'Department'){
                        outletService.loadOutletDepartments(outlet.id).then(promise => {
                            angular.forEach(promise, (dep) => {
                                if (dep.id === savedOutlet.id) {
                                    outlet.selected = true;
                                    dep.selected = true;
                                    _.remove(savedReport.departments, (department) => department.id === dep.id);
                                    savedReport.departments.push(dep);
                                }
                            });
                            vm.selectAll = vm.popupObject.getCountSelected() === outlets.length;
                        }).catch(() => {
                            // log
                        });
                    }
                    else {
                        outletService.loadOutletDepartments(savedOutlet.id).then(promise => {
                            angular.forEach(promise, (dep) => {
                                if (outlet.id === savedOutlet.id) {
                                    outlet.selected = true;
                                }
                                dep.selected = true;
                                _.remove(savedReport.departments, (department) => department.id === dep.id);
                                savedReport.departments.push(dep);
                            });

                            vm.selectAll = vm.popupObject.getCountSelected() === outlets.length;
                        }).catch(() => {
                            // log
                        });

                        vm.selectAll = vm.popupObject.getCountSelected() === outlets.length;
                     }
                });
            });
        }

        vm.showEmailOption = appConfig.isMCAdmin;

        // Get the beneficiary field names
        vm.allSelected = vm.isAllSelected();

        const merchant = merchantService.merchantInfo;

        vm.merchant = merchant;
        vm.showFulfilledByCheck = merchantService.behaviour(merchant, 'transReportPage.showFulfilledByCheck');
        vm.showFulfilledDateCheck = merchantService.behaviour(merchant, 'transReportPage.showFulfilledDateCheck');
        vm.showPosItemCodeCheck = merchantService.behaviour(merchant, 'transReportPage.showPosItemCodeCheck');
        vm.showCSVOption = !merchantService.behaviour(merchant, 'transReportPage.showDepartments');

        if (merchantService.behaviour(merchant, 'transReportPage.showExtendedScheduleIntervals')) {
            vm.scheduleIntervals = reportService.getExtendedScheduleIntervals();
        } else {
            vm.scheduleIntervals = reportService.getScheduleIntervals();
        }

        if (vm.departments.length > 0) {
            updateDepartmentsList(vm.transactionReport.reportSpec, vm.departments);
            updateDepartmentsList(vm.transactionReportTemplate.reportSpec, vm.departments);
        }

        if(merchantService.merchantInfo.businessCategory.name === 'School') {
            reportService.getStickerReportFilters()
                .then(promise => {
                    vm.templateReport.headers = transformHeader(angular.copy(promise.groupByList));
                    vm.templateReportTemplate.headers = transformHeader(angular.copy(promise.groupByList));

                    if (isUpdating) {
                        for (let i = 0; i < vm.templateReportTemplate.headers.length; i++) {
                            vm.templateReportTemplate.headers[i].selected = savedReport.customFields
                                .includes(vm.templateReportTemplate.headers[i].name);
                        }
                    }

                })
                .catch(() => {
                    // log
                });
        }

    };

    vm.popupObject = (function() {
        return {
            getCountSelected() {
                if(!savedReport || !savedReport.departments){
                    return 0;
                }
                return savedReport.departments.length;
            },

            manageSelectedOutlet(selected, outletId) {
                if(!outletId){
                    return;
                }
                if(!savedReport.departments) {
                    savedReport.departments = [];
                }

                if(selected){
                    outletService.loadOutletDepartments(outletId).then(promise => {
                        angular.forEach(promise, (dep) => {
                            dep.selected = true;
                            savedReport.departments.push(dep);
                            vm.selectAll = vm.popupObject.getCountSelected() === outlets.length;
                         })
                    }).catch(() => {
                        // log
                    });
                }
                else {
                    outletService.loadOutletDepartments(outletId).then(promise => {
                        angular.forEach(promise, (dep) => {
                            dep.selected = false;
                            _.remove(savedReport.departments, (department) => department.id === dep.id);
                            vm.selectAll = false;
                        })
                    }).catch(() => {
                        // log
                    });
                }
            },
            manageSelectAll(all) {
                vm.selectAll = all;
            },
            selectAllNone(selected) {
                savedReport.merchantLocs = [];
                savedReport.departments = [];

                if(selected){
                    angular.forEach(vm.outlets, (outl) => {
                         outletService.loadOutletDepartments(outl.id).then(promise => {
                            angular.forEach(promise, (dep) => {
                                dep.selected = true;
                                savedReport.departments.push(dep);
                            })
                        }).catch(() => {
                             // log
                         });
                    });
                }
            }
        };
    })();

    vm.openFilterPopup = function() {
        setSelectedOutlets(savedReport.merchantLocs);
        vm.popupObject.show = true;
    };

    vm.closePopupFilter = function() {
        vm.popupObject.show = false;
    };

    // This function is to set that array that's going to be sent , It's going to loop over because is easier to keep...
    // Than remove and add
    function setSelectedOutlets(selectedOutlets) {
        vm.outletsSelected = [];
        if (selectedOutlets.length === 0) {
            // vm.selectAll = false;
            vm.popupObject.manageSelectAll(false);
        }
        else {
            vm.outletsSelected = selectedOutlets;
        }
    }

    vm.unselectedFiltered = function(selected, outletId) {
        vm.popupObject.manageSelectedOutlet(selected, outletId);
    };

    vm.selectAllOrNone = function(selected) {
        angular.forEach(outlets, (outlet) => {
            outlet.selected = selected;
        });

        vm.popupObject.selectAllNone(selected);
    };

    vm.getNumberOutletText = function() {
        return vm.popupObject.getCountSelected(vm.SCHEDULE) === 0;
    };

    function loadSavedReport(savedReport) {
        vm.transactionReportTemplate.reportSpec = savedReport;

        if (vm.transactionReportTemplate.reportSpec.sendProtocolParams) {
            vm.transactionReportTemplate.reportSpec.sendProtocolParams.password = '';
        }// QKRD-6040 clear this down to force entry on each edit

        vm.transactionReportTemplate.reportSpec.scheduleDayOfMonth =
            parseInt(vm.transactionReportTemplate.reportSpec.scheduleDayOfMonth);
        utils.setSelectedDays(vm.transactionReportTemplate.reportSpec.scheduleDay, vm.days);

        if (savedReport.reportSubType.indexOf('_csv', savedReport.reportSubType.length - '_csv'.length) !== -1) {
            savedReport.reportFileType = 'csv';
            if (savedReport.reportSubType.indexOf(APP_CONSTANT.REPORT_TRANSACTION_DETAILS) !== -1) {
                savedReport.reportSubType = APP_CONSTANT.REPORT_TRANSACTION_DETAILS;
            }
        } else {
            savedReport.reportFileType = 'xls';
        }
    }

    /** Called when day is toggled in daily report */
    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.dateOptions = {
        startingDay: merchantService.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    vm.init();
});



// WEBPACK FOOTER //
// ./src/reports/outlet/shared/transaction.outlet.controller.js